import { all, call, put, takeLatest } from 'redux-saga/effects';
import Api from '../../services/Api';
import { loadingError } from '../../util/error';
import { LOGIN_ERROR, LOGOUT_ERROR, RESET_PASSWORD_ERROR, SEND_PASSWORD_RECOVERY_ERROR } from '../constants/errorCodes';
import {
    IS_LOADING,
    LOGIN_FAILED,
    LOGIN_REQUESTED,
    LOGIN_SUCCEEDED,
    LOGOUT_FAILED,
    LOGOUT_REQUESTED,
    LOGOUT_SUCCEEDED,
    RESETTING_PASSWORD_FAILED,
    RESETTING_PASSWORD_SUCCEEDED,
    RESET_PASSWORD,
    SENDING_PASSWORD_RECOVERY_FAILED,
    SENDING_PASSWORD_RECOVERY_SUCCEEDED,
    SEND_PASSWORD_RECOVERY,
    SET_LOADING_SUCCEEDED
} from '../constants/actionTypes';

function* login( action ) {

    try {

        const response = yield call( Api.login, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOGIN_SUCCEEDED, payload: { token: response.data, username: action.payload.username } } );

        } else {

            yield loadingError( LOGIN_FAILED, LOGIN_ERROR );

        }

    } catch( e ) {

        yield loadingError( LOGIN_FAILED );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* logout( action ) {

    try {

        const response = yield call( Api.logout, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOGOUT_SUCCEEDED, payload: { token: response.data } } );

        } else {

            yield loadingError( LOGOUT_FAILED, LOGOUT_ERROR );

        }

    } catch( e ) {

        yield loadingError( LOGOUT_FAILED );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* resetPassword( action ) {

    try {

        const response = yield call( Api.resetPassword, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: SET_LOADING_SUCCEEDED, payload: { type: RESETTING_PASSWORD_SUCCEEDED } } );

        } else {

            yield loadingError( RESETTING_PASSWORD_FAILED, RESET_PASSWORD_ERROR );

        }

    } catch( e ) {

        yield loadingError( RESETTING_PASSWORD_FAILED );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* sendPasswordRecovery( action ) {

    try {

        const response = yield call( Api.sendPasswordRecovery, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: SET_LOADING_SUCCEEDED, payload: { type: SENDING_PASSWORD_RECOVERY_SUCCEEDED } } );

        } else {

            yield loadingError( SENDING_PASSWORD_RECOVERY_FAILED, SEND_PASSWORD_RECOVERY_ERROR );

        }

    } catch( e ) {

        yield loadingError( SENDING_PASSWORD_RECOVERY_FAILED );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* authSaga() {

    yield all( [
        takeLatest( LOGIN_REQUESTED,        login                ),
        takeLatest( LOGOUT_REQUESTED,       logout               ),
        takeLatest( RESET_PASSWORD,         resetPassword        ),
        takeLatest( SEND_PASSWORD_RECOVERY, sendPasswordRecovery )
    ] );

}

export default authSaga;